import { type ReactElement } from 'react';

import {
  ChatAttachPreview,
  type ChatAttachPreviewItem,
} from '@/shared/chat/chat-attach-preview.js';
import { ChatAttachVideoPreview, ChatAttachVideoThumb } from '@/shared/chat/chat-attach-video.js';

const ADD_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif,video/mp4';

export interface StaffChatPendingAttachment {
  readonly previewUrl: string;
  readonly fileName: string;
  readonly isVideo: boolean;
}

interface StaffChatAttachConfirmProps {
  readonly items: readonly StaffChatPendingAttachment[];
  readonly selectedIndex: number;
  readonly uploading: boolean;
  readonly onSelect: (index: number) => void;
  readonly onCancel: () => void;
  readonly onConfirm: (captions: readonly (string | undefined)[]) => void;
  readonly onAddFiles?: (files: readonly File[]) => void;
}

/** Preview before upload, laid out like the WhatsApp attachment composer. */
export function StaffChatAttachConfirm({
  items,
  selectedIndex,
  uploading,
  onSelect,
  onCancel,
  onConfirm,
  onAddFiles,
}: StaffChatAttachConfirmProps): ReactElement {
  const selected = items[selectedIndex] ?? items[0];
  const previewItems: ChatAttachPreviewItem[] = items.map((item) => ({
    key: item.previewUrl,
    preview: item.isVideo ? (
      <ChatAttachVideoPreview src={item.previewUrl} />
    ) : (
      <img src={item.previewUrl} alt={item.fileName} />
    ),
    thumbnail: item.isVideo ? (
      <ChatAttachVideoThumb src={item.previewUrl} />
    ) : (
      <img src={item.previewUrl} alt="" />
    ),
  }));

  return (
    <ChatAttachPreview
      dialogLabel={
        selected?.isVideo === true ? 'Confirmar envio do vídeo' : 'Confirmar envio da imagem'
      }
      items={previewItems}
      selectedIndex={selectedIndex}
      uploading={uploading}
      addAccept={ADD_ACCEPT}
      onSelect={onSelect}
      {...(onAddFiles !== undefined ? { onAddFiles } : {})}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
